import API from "../../Utils/API";
import { jwtDecode } from "jwt-decode";

export const userService = async (credentials, isUser) => {
   try {
      const response = await API({
         method: "POST",
         url: isUser ? "/login" : "/register",
         requestConfig: { ...credentials },
      });

      if (isUser && response.data) {
         const { token } = response.data;
         const decodedUser = jwtDecode(token);

         localStorage.setItem("authToken", token); // Store token in localStorage

         return { ...response, decodedUser };
      }

      return response;
   } catch (error) {
      const errorMessage =
         error.response?.data?.message || "Authentication failed due to an unknown error.";
      throw new Error(errorMessage);
   }
};

export const logoutUser = () => {
   localStorage.removeItem("authToken"); // Clear token on logout
   return { token: null, user: {} };
};

export const fetchUserData = async (id) => {
   const response = await API({
      url: "/user/",
      requestConfig: {
         params: {
            id: id,
         },
      },
   });

   return response;
};
